import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'burned caravan? are these "the boys"?',
    'how many more are left? how far ahead of me are they?',
    'I have to press on. must travel faster if I am to catch up.'
  ],
  buttons: [nextAction('Continue', onDone)]
});

const gossip = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'a group of men passed through recently. drunkenly bragged about loot and murder.',
    'an entire caravan burned out. women... children... everyone dead.',
    'these two straggled and were left behind. ',
    'townfolk have no patience for outlaws and justice was swift.',
    'the freshly deceased McKenzie brothers.'
  ],
  buttons: [nextAction('What business?', () => onDone(end(onDone)))]
});

const start = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'on the outskirts of town there are 2 bodies swinging lazily by the neck.',
    'still fresh.',
    "town's all abuzz about it. I catch pieces of gossip."
  ],
  buttons: [nextAction('Listen', () => onDone(gossip(onDone)))]
});

export default start;
